import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    skepmenu_open: false,
    skepmenu_anchor: null,
    editmenu_open: false,
    editmenu_anchor: null,
    opstelSidedrawer_open: false,
    grenseGeteken: [],
    kanTeken: false,
    edittypemode: null,
    opstelAction: null,
    cancelAddGrens: null,
    dup_blok: null,
};

const toggleSkepMenuitems = (state, action) => {
    return updateObject(state, { skepmenu_open: action.anchor ? true : false, skepmenu_anchor: action.anchor });
};

const toggleEditMenuitems = (state, action) => {
    return updateObject(state, { editmenu_open: action.anchor ? true : false, editmenu_anchor: action.anchor });
};

const openOpstellingSidedrawer = (state, action) => {
    return updateObject(state, { opstelSidedrawer_open: true });
};

const closeOpstellingSidedrawer = (state, action) => {
    return updateObject(state, { opstelSidedrawer_open: false, dup_blok: null });
};

const cancelAddGrens = (state, action) => {
    return updateObject(state, { cancelAddGrens: action.key });
};

const addGrens = (state, action) => {
    let temp = [...state.grenseGeteken];
    let index = temp.findIndex(x => x.key === action.grens.key);
    if (index === -1) {
        if (state.cancelAddGrens !== action.grens.key) {
            temp.push(action.grens);
        }
    } else {
        if (state.cancelAddGrens !== action.grens.key) {
            temp[index] = action.grens;
        }
    }
    return updateObject(state, { grenseGeteken: [...temp], cancelAddGrens: null });
};

const removeGrens = (state, action) => {
    let temp = [...state.grenseGeteken];
    let index = temp.findIndex(x => x.key === action.key);
    if (index !== -1) {
        temp.splice(index, 1);
    }
    return updateObject(state, { grenseGeteken: [...temp] });
};

const clearGrense = (state, action) => {
    return updateObject(state, { grenseGeteken: [] });
};

const setKanTeken = (state, action) => {
    return updateObject(state, { kanTeken: action.kanTeken });
};

const setEditModeType = (state, action) => {
    return updateObject(state, { opstelAction: action.action, edittypemode: action.mode });
};

const handleDupliseerBlok = (state, action) => {
    return updateObject(state, {
        opstelSidedrawer_open: true,
        opstelAction: "skep",
        dup_blok: action.data
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.TOGGLE_SKEPMENUITEMS:
            return toggleSkepMenuitems(state, action);
        case actionTypes.TOGGLE_EDITMENUITEMS:
            return toggleEditMenuitems(state, action);
        case actionTypes.OPEN_OPSTELLINGSIDEDRAWER:
            return openOpstellingSidedrawer(state, action);
        case actionTypes.CLOSE_OPSTELLINGSIDEDRAWER:
            return closeOpstellingSidedrawer(state, action);
        case actionTypes.ADD_GRENS:
            return addGrens(state, action);
        case actionTypes.CANCEL_ADD_GRENS:
            return cancelAddGrens(state, action);
        case actionTypes.REMOVE_GRENS:
            return removeGrens(state, action);
        case actionTypes.CLEAR_GRENSE:
            return clearGrense(state, action);
        case actionTypes.SET_TEKENMODE:
            return setKanTeken(state, action);
        case actionTypes.SET_EDITMODETYPE:
            return setEditModeType(state, action);
        case actionTypes.DUPLISEER_BLOK:
            return handleDupliseerBlok(state, action);
        default:
            return state;
    }
};

export default reducer;